/**
 * Anonymisierungs-Utilities
 * 
 * Ersetzt schützenswerte Daten durch Platzhalter
 */

/**
 * Ersetzt schützenswerte Daten durch Platzhalter
 * @param {string} text - Der zu anonymisierende Text
 * @returns {{text: string, replaced: boolean}} - Anonymisierter Text und Flag ob etwas ersetzt wurde
 */
export function anonymizeText(text) {
  if (!text || typeof text !== 'string') {
    return { text: text || '', replaced: false };
  }

  let replaced = false;
  let anonymized = text;

  // E-Mail-Adressen
  anonymized = anonymized.replace(/([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g, '[EMAIL]');
  
  // Telefonnummern (CH-Format und international)
  anonymized = anonymized.replace(/(\+41\s?\d{2}\s?\d{3}\s?\d{2}\s?\d{2}|0\d{2}\s?\d{3}\s?\d{2}\s?\d{2})/g, '[PHONE]');
  
  // IBAN (CH)
  anonymized = anonymized.replace(/CH\d{2}\s?\d{4}\s?\d{4}\s?\d{4}\s?\d{4}\s?\d{1}/g, '[IBAN]');
  
  // Geburtsdatum (z.B. 01.01.1990)
  anonymized = anonymized.replace(/\b\d{2}\.\d{2}\.\d{4}\b/g, '[BIRTHDATE]');
  
  // Kreditkartennummern (Visa/Mastercard, 16-stellig)
  anonymized = anonymized.replace(/\b\d{4}[- ]?\d{4}[- ]?\d{4}[- ]?\d{4}\b/g, '[CREDITCARD]');
  
  // AHV-Nummer (Schweiz)
  anonymized = anonymized.replace(/\b756\.\d{4}\.\d{4}\.\d{2}\b/g, '[AHV]');
  
  // Passnummer (8-9 Zeichen, Buchstaben/Zahlen)
  anonymized = anonymized.replace(/\b[A-Z0-9]{8,9}\b/g, '[PASSPORT]');
  
  // PLZ (Schweiz, 4-stellig, nicht am Satzanfang)
  anonymized = anonymized.replace(/(?<!^)\b\d{4}\b/g, '[PLZ]');
  
  // Kundennummer/Vertragsnummer (Beispiel: KND-123456, VTR-987654)
  anonymized = anonymized.replace(/\b(KND|VTR)-\d{4,}\b/g, '[CUSTOMERNO]');
  
  // IP-Adresse
  anonymized = anonymized.replace(/\b\d{1,3}(?:\.\d{1,3}){3}\b/g, '[IP]');
  
  // URLs
  anonymized = anonymized.replace(/https?:\/\/[\w\-\.\/?#&=]+/g, '[URL]');
  
  // Adressen (vereinfachtes Beispiel: Strasse/Str./Weg/Platz + Zahl)
  anonymized = anonymized.replace(/\b([A-ZÄÖÜ][a-zäöüß]+(strasse|str\.|weg|platz)\s?\d{1,4})\b/gi, '[ADDRESS]');
  
  // Prüfe, ob etwas ersetzt wurde
  replaced = /\[EMAIL\]|\[PHONE\]|\[IBAN\]|\[BIRTHDATE\]|\[CREDITCARD\]|\[AHV\]|\[PASSPORT\]|\[PLZ\]|\[BIC\]|\[CUSTOMERNO\]|\[IP\]|\[URL\]|\[ADDRESS\]/.test(anonymized);
  
  return { text: anonymized, replaced };
}
